<template>
  <div class="update-card">
    <i :class="['fal', 'fa-2x', 'fa-fw', icon]" />
    <div class="card-text">
      <template v-for="fragment in fragments">
        <a v-if="fragment.url && (fragment.url !== '')" :href="fragment.url">{{fragment.text}}</a>
        <template v-else>{{fragment.text || fragment}}</template>
      </template>
      <div class="when">{{when}}</div>
    </div>
  </div>
</template>

<script>
  import map from './map'

  export default {
    name: 'card',

    props: { card: Object },

    computed: {
      icon() { return this.getMap(this.card.Type, this.card.Action).icon },

      fragments() { return map.tokenize(this.getMap(this.card.Type, this.card.Action).template, this.card) },

      when() {
        var date = global.moment(this.card.Date)
        var duration = global.moment.duration(date.diff(new Date()))

        return global.moment.duration(duration).humanize(true)
      }
    },

    methods: {
      getMap: (type, action) => (map[type] && map[type][action] || map.default)
    }
  }
</script>

<style lang="scss" scoped>
  @import "~@/assets/sass/_variables.scss";

  a[href] {
    color: $href-blue-color
  }
  .update-card {
    padding: 10px 0;

    @include theme {
      border-bottom: 1px solid v(background-light);
    }
  }

  i {
    display: table-cell;
    vertical-align: top;

    @include theme {
      color: v(ink-light);
    }
  }

  a {
    font-weight: 900;
    text-transform: uppercase;
  }

  .card-text {
    font-size: $font-size-xsmall;
    display: table-cell;
    vertical-align: top;
    padding-left: 10px;
  }

  .when {
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/_modules/Dashboard/widgets/RecentUpdates/card.vue